<template>
  <div class="py-5 px-5">
    <titulo-seccion>Algunos de nuestros casos de éxito</titulo-seccion>
    <div class="d-flex justify-content-center flex-wrap align-items-center pt-4 mt-2 pb-4">
      <div v-for="(item,index) in Cliente" :key="index">
        <img :src="item.imagen" :title="item.nombre" :alt="item.nombre" width="250" />
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      Cliente: []
    };
  },
  computed: {
    ...mapState(["Clientes"])
  },
  created() {
    this.mostrarClientes();
  },
  methods: {
    mostrarClientes() {
      /* El reverse y el slice es para mostrar los primeros 5 elementos */
      this.Clientes.slice(0,5).forEach(element => {
        this.Cliente.push(element);
      });
    }
  }
};
</script>
